export default function ({ store, redirect }) {
  // Redirect to home if current user is not chef
  if (process.client && store.state.staff.currentRole !== 'Chef') {
    return redirect('/')
  }
}
